import { ReactNode, useState } from 'react'
import { Box } from '@mui/material'
import { Alert, AlertProps } from '@carto/meridian-ds/components'
import { getLocalStorageItem, setLocalStorageItem } from 'app/api/localStorage'

type Props =
  | {
      children: ReactNode
      removable: true
      lsKey: string
    }
  | { children: ReactNode; removable?: false; lsKey?: undefined }

export function ShareWithGroupsAlert({ removable = false, children, lsKey, ...otherProps }: Props & AlertProps) {
  const isRemovedLocalStorage = getLocalStorageItem(`${lsKey}_showing`)
  const [isRemoved, setIsRemoved] = useState(isRemovedLocalStorage)

  const handleRemovable = removable
    ? () => {
        setIsRemoved(true)
        setLocalStorageItem(`${lsKey}_showing`, true)
      }
    : undefined

  if (isRemoved) {
    return null
  }

  return (
    <Box pt={1.5}>
      <Alert onClose={handleRemovable} severity="neutral" {...otherProps}>
        {children}
      </Alert>
    </Box>
  )
}
